import React, { useContext } from "react";

import UiContext from "../../../context/UiContext";
import AddForm from "../../AddForm";
import useSWR from "swr";
import groq from "groq";
import sanityClient from "../../../data/sanityClient";
import AuthContext from "../../../context/AuthContext";

export const AddPinModal: React.FC = () => {
  const { state: authState } = useContext(AuthContext);
  const { closeModal, openModal, state } = React.useContext(UiContext);

  const { mutate } = useSWR(groq`*[_type == "entry"]`, (query) =>
    sanityClient.fetch(query)
  );

  const { data } = useSWR(groq`*[_type == "category"]`, (query) =>
    sanityClient.fetch(query)
  );

  const onCompleted = () => {
    mutate();
    closeModal();
  };

  const categories = data?.map((item: any) => ({
    value: item._id,
    text: item.title,
  }));

  return (
    <AddForm
      userName={authState.userName}
      userEmail={authState.userEmail}
      location={state.picker.selectedLocation}
      categories={categories}
      onGoBack={() => closeModal()}
      onCompleted={onCompleted}
    />
  );
};
